<template>
  <div v-if="schedule.item.category === 'breakTime'">
    <div>휴식</div>
    <div>시작시간: {{ item.startTime }}</div>
    <div>종료시간: {{ item.endTime }}</div>
  </div>
  <div v-else-if="schedule.item.category === 'delivery'">
    <div v-if="item.state.configValue === 'dvry_to_be_done'">
      <div>예약자: {{ item.customer.name }}</div>
      <div>배송 물품: {{getDeliveryParcelType(item)}}</div>
      <div>출발지: {{item.expectedDeparture}}</div>
      <div>도착지: {{item.expectedDestination}}</div>
      <div>예상출발시간: {{item.expectedStartTime}}</div>
      <div>예상도착시간: {{item.expectedEndTime}}</div>
    </div>
    <div v-else>
      <div>예약자: {{ item.customer.name }}</div>
      <div>배송 물품: {{getDeliveryParcelType(item)}}</div>
      <div>배송완료시간: {{ item.realEndTime }}</div>
    </div>
  </div>
  <div v-else>
    <div>예약자: {{ item.customerName }}</div>
    <div>구분: {{getSuburbanString(item)}}/{{getTripTypeString()}}</div>
    <div>출발지: {{ item.departure }}</div>
    <div v-if="item.departureComment">
      <span class="mr-11"></span>{{ item.departureComment }}
    </div>
    <div v-if="item.waypoint1">경유지1: {{ item.waypoint1 }}</div>
    <div v-if="item.waypoint1 && item.waypoint1Comment">
      <span class="mr-11"></span>{{ item.waypoint1Comment }}
    </div>
    <div v-if="item.waypoint2">경유지2: {{ item.waypoint2 }}</div>
    <div v-if="item.waypoint2 && item.waypoint2Comment">
      <span class="mr-11"></span>{{ item.waypoint2Comment }}
    </div>
    <div v-if="item.waypoint3">경유지3: {{ item.waypoint3 }}</div>
    <div v-if="item.waypoint3 && item.waypoint3Comment">
      <span class="mr-11"></span>{{ item.waypoint3Comment }}
    </div>
    <div>도착지: {{ item.destination }}</div>
    <div v-if="item.destinationComment">
      <span class="mr-11"></span>{{ item.destinationComment }}
    </div>
    <div>출발시간: {{ item.startTime }}</div>
    <div>종료시간: {{ item.endTime }}</div>
  </div>
</template>
<script>
export default {
  props: {
    schedule: {
      type: Object,
    },
  },
  computed: {
    item() {
      return this.schedule.item.item;
    }
  },
  methods: {
    getDeliveryParcelType(item) {
      const configParcels = JSON.parse(item.parcelType);
      return configParcels.map(item => item.configName).join();
    },
    getSuburbanString(item) { // 시내 / 시외만 구분
      if (!item || !item.fareType) {
        return '';
      }

      return item.fareType.startsWith('suburban') ? '시외' : '시내';
    },
    getTripTypeString() { // 현재는 왕복 예약이 없으므로 편도만 지정
      return '편도';
    },
  }
};
</script>
